import * as React from 'react';

import ContentPlaceholder from 'basics/loaders/ContentPlaceholder/ContentPlaceholder';
import { Bar } from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

import { BottomRow, Header } from 'pages/delegate/components/Delegatee/Delegatee.styled';

import DelegateDetailsPrompt from './DelegateDetailsPrompt';
import { ButtonMobile, List } from './DelegatesList.styled';
import {
    Avatar,
    Card,
    Description,
    FooterValue,
    MobileVotingPower,
    VotingPower,
} from './DelegatesLoading.styled';

const DelegatesLoading = ({ personal = false }: { personal?: boolean }) => (
    <ContentPlaceholder label={personal ? 'Loading my delegates' : 'Loading delegates'}>
        <List>
            {!personal && (
                <ButtonMobile isBig fullWidth isRounded disabled>
                    Delegate ICE
                </ButtonMobile>
            )}
            {Array.from({ length: 3 }, (_, index) => (
                <Card key={index} $isSelected={false}>
                    <Header aria-hidden="true">
                        <Avatar $width="4.8rem" $height="4.8rem" $circle />
                        <Bar $width="12rem" $height="2rem" />
                        <VotingPower>
                            <Bar $width="18rem" />
                            <Bar $width="16rem" />
                        </VotingPower>
                    </Header>
                    <MobileVotingPower>
                        <Bar $width="20rem" />
                        {!personal && <Bar $width="18rem" />}
                    </MobileVotingPower>
                    <Description>
                        <Bar $width="100%" />
                        <Bar $width="85%" />
                        <Bar $width="100%" />
                        <Bar $width="65%" />
                    </Description>
                    <BottomRow>
                        <FooterValue>
                            <Bar $width="14rem" />
                        </FooterValue>
                        <FooterValue>
                            <Bar $width="17rem" />
                        </FooterValue>
                    </BottomRow>
                    {!personal && index === 0 && <DelegateDetailsPrompt />}
                </Card>
            ))}
        </List>
    </ContentPlaceholder>
);

export default DelegatesLoading;
